import script from "./TempFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./TempFooter.vue?vue&type=script&setup=true&lang=js"

import "@/assets/plantilla/style.css?vue&type=style&index=0&id=e5f1fd2e&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5f1fd2e"]])

export default __exports__